module.exports = __webpack_public_path__ + "static/media/icon-video-pause.d5d927db.svg";